/* eslint-disable max-len */
import React from "react";
import "./diwali-merch-page.m.css";
// import { useUserSubscription } from "../../helper/hooks";
// import { SubscriberOnlyNudge } from "./subscriber-only-nudge";

export function DiwaliMerchPage() {
  const handleBuyNow = planId => () => {
    window.open(`https://razorpay.com/payment-button/${planId}/view`, "_blank");
  };

  return (
    <div styleName="wrapper">
      <h1 styleName="title">Celebrate Deepavali with our special hampers!</h1>
      <br />
      <div styleName="top-wrapper">
        <div styleName="img-wrap">
          <img
            alt="banner"
            src="https://images.assettype.com/newslaundry/2026-11-03/76nv0spm/Diwali-Hamper-website-banner.jpg"
          />
        </div>
        <div styleName="text-wrap">
          <p styleName="description">
            {" "}
            We celebrate festivals for a number of reasons. This year, Newslaundry and The News Minute are adding one more to this list:{" "}
            <strong>
              <i>The spirit of independent journalism.</i>
            </strong>
            <br />
            <br />
            Explore our merchandise and proudly represent a community that
            powers free, and independent journalism.
            <br />
            <br />
            Or gift these items to friends and family to encourage them to join our tribe.
            <br />
            <br/>
            And fun fact: This Deepavali, we’re also hosting a lucky draw! 10 lucky people (drawn at random) will be receiving a signed copy of one of our comic books! To enter this draw, just purchase our hamper(s) and let the festive gods do the rest!
   <br/>   <br/>
If you’re one of the lucky 10, don’t forget to post a picture of the signed goodies on social media! We’ll give you a special shoutout!

          </p>
        </div>
      </div>
      <br />
      <div styleName="hamper__container">
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper One</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2026-11-03/992dd0z2/HAMPER-1.jpg"
            // style={{ margin: "-90px" }}
          />

          <ul style={{ height: "70%" }}>
            <li>Naxalbari comic worth ₹799/-</li>
                 <li>Two Month Joint NL-TNM Subscription worth ₹1098/-</li>
                 <li>Kashmir ki Kahani comic worth ₹1499/-</li>
                  <li>NL-TNM mug worth ₹499/-</li>
                  <li>Urban Naxal Mug worth ₹499/-</li>
                   <li>Candle scented worth 799</li>
                  <li>Melody Toffee worth ₹20/-</li>
                  <li>Seed Crackers worth ₹549/-</li>
     
          </ul>
           <h2 styleName="hamper__price-1" >
            <span styleName="rupee_sign1">Total{' '}</span>
            <span styleName="rupee_sign1">₹</span>
            <span styleName="rupee_sign1" style={{ textDecoration: 'line-through' }}>5,762</span>
          </h2>
          <h2 styleName="hamper__price-1">
            
            <span styleName="rupee_sign">₹</span>5,200
          </h2>
          {/* {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_IDxBceYSd3ggkJ")}>Buy Now</button>
            )} */}
          <button onClick={handleBuyNow("pl_TviEGabkbzgq8d")}>Buy Now</button>
        </div>
        <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper Two</h2>
          <img
            alt=""
            // src="https://images.assettype.com/newslaundry/2021-10/ec1a2962-f4e7-479c-a983-9b16c2fbe4fc/Diwali_Hamper_2_2_.jpg"
            src="https://images.assettype.com/newslaundry/2026-11-03/rn50y0tn/HAMPER-2.jpg"
            // style={{ margin: "-75px" }}
          />

          <ul style={{ height: "70%" }}>
              <li>Naxalbari comic worth ₹799/-</li>
                  <li> One Month Joint NL-TNM Subscription worth ₹549/-</li>
            <li>Kashmir Ki Kahani Comic worth ₹1499/-</li>
              <li>NL-TNM mug worth ₹499/-</li>
             <li>Candle scented worth 799</li>
                  <li>Melody Toffee worth ₹20/-</li>
           
          
          </ul>
          <h2 styleName="hamper__price-1" >
            <span styleName="rupee_sign1">Total{' '}</span>
            <span styleName="rupee_sign1">₹</span>
            <span styleName="rupee_sign1" style={{ textDecoration: 'line-through' }}>4,165</span>
          </h2>
          <h2 styleName="hamper__price-2">
            <span styleName="rupee_sign">₹</span>3,750
          </h2>
          {/* {subscriptionLoading ? (
            <button disabled={true} aria-disabled="true">
              Loading...
            </button>
          ) : (
            <button onClick={handleBuyNow("pl_IDxFgSepurUXrE")}>Buy Now</button>
            )} */}
          <button onClick={handleBuyNow("pl_TviDEbspyEypWN")}>Buy Now</button>
        </div>
        {/* <div styleName="hamper__card">
          <h2 styleName="hamper__title">Hamper Three</h2>
          <img
            alt=""
            src="https://images.assettype.com/newslaundry/2021-10/acaa0e7a-7c68-4dbb-a6ce-9b20c46843d7/Diwali_Hamper_3_2_.jpg"
            style={{ marginTop: "-5px" }}
          />
          
          <ul>
            <li>Candle</li>
            <li>Fridge Magnets</li>
            <li>Karare Chane Mug</li>
            <li>Tote bag</li>
            <li>Flask</li>
            <li>Laptop Stickers</li>
            <li>Car Stickers</li>
            <li>Naxalbari Comic</li>
            <li>Gift 2x Six Months Disruptor Subscriptions</li>
          </ul>
          <h2 styleName="hamper__price-3">
            <span styleName="rupee_sign">₹</span>2599
          </h2>
          <button onClick={handleBuyNow("pl_IDxIssRYKq1uyV")}>Buy Now</button>
        </div> */}
      </div>
      <div>
        <strong>Terms &amp; Conditions</strong>
      </div>
      <ul styleName="notes_wrapper">
        <li styleName="notes_lines">
          • This is a limited period offer till October 27, 2025.
        </li>
        <li styleName="notes_lines">• Delivery in India only. </li>
        <li styleName="notes_lines">
          • If you already have a subscription, you can gift the subscription to
          your friend/family.<br/>
          Just email us at <a
            style={{ color: "var(--text-accent-muted)" }}
            href="mailto:subscription@newslaundry.com"
          >
            subscription@newslaundry.com
          </a>.
        </li>
        <li styleName="notes_lines">
          • If you are based out of India, you can share an Indian address for
          the merch delivery.
        </li>
        <li styleName="notes_lines">
          • Please note, delivery of packages will take at least two to three
          weeks. Please be patient with us.
        </li>
        <li styleName="notes_lines">
          • Once you gift a subscription, it will be mapped within 48 hours.
        </li>
        <li styleName="notes_lines">
          • The product images shown may not be an exact representation of the
          product.
        </li>
        <li styleName="notes_lines">
          • If you have any queries, please drop an email on{" "}
          <a
            style={{ color: "var(--text-accent-muted)" }}
            href="mailto:store@newslaundry.com"
          >
            store@newslaundry.com
          </a>.
        </li>
      </ul>
      <br />
    </div>
  );
}
